import {Injectable, Injector} from '@angular/core';
import {BaseService} from '@twpub/core/services/base.service';
import {SearchFilter} from '@twpub/core/models';
import {Observable, shareReplay} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchFilterService extends BaseService {
  constructor(private injector: Injector) {
    super(injector);
  }

  public getSearchFilters(dictIds: number[]): Observable<SearchFilter[]> {
    return this.http.get<SearchFilter[]>(this.url(`/filters/${dictIds}`)).pipe(shareReplay(1));
  }
}
